import { render } from "./TokenAuth.vue?vue&type=template&id=5d04b6fe&scoped=true"
import script from "./TokenAuth.vue?vue&type=script&lang=js"
export * from "./TokenAuth.vue?vue&type=script&lang=js"

import "./TokenAuth.vue?vue&type=style&index=0&id=5d04b6fe&lang=scss&scoped=true"
import "./TokenAuth.vue?vue&type=style&index=1&id=5d04b6fe&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d04b6fe"]])

export default __exports__